export const toSentenceCase = (str: string) => {
	return str.toLowerCase().replace(/([a-z])/, (match) => {
		return match.toUpperCase();
	});
};
